export default class Logger {
    public static log(...msg:any[]) {
        console.log(...msg);
    }

    public static error(...msg:any[]) {
        console.error(...msg);
    }
}